export default "__VITE_ASSET__8L4rlYiG__"